import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Splash } from "@/components/Layout";

export const STATE_KEY = "ks_oauth_state";
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const googleRedirect = () => window.location.origin + "/auth/google";

export const startGoogle = (clientId) => {
  const state = crypto.getRandomValues(new Uint32Array(4)).join("");
  sessionStorage.setItem(STATE_KEY, state);
  const q = new URLSearchParams({ client_id: clientId, redirect_uri: googleRedirect(), response_type: "code",
    scope: "openid email profile", state, prompt: "select_account" });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${q}`;
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const p = new URLSearchParams(window.location.search);
    const forPartner = localStorage.getItem("ks_google_for") === "partner";
    localStorage.removeItem("ks_google_for");
    const fail = (msg) => { toast.error(msg); if (!forPartner) setUser(false); navigate(forPartner ? "/partner" : "/login", { replace: true }); };
    const state = sessionStorage.getItem(STATE_KEY);
    sessionStorage.removeItem(STATE_KEY);
    if (p.get("error")) return fail("Google login was cancelled.");
    if (!p.get("code") || !state || p.get("state") !== state) return fail("Login link expired. Please try again.");
    if (forPartner) {
      api.post("/staff/google", { code: p.get("code"), redirect_uri: googleRedirect() })
        .then(({ data }) => {
          if (data.token) { localStorage.setItem("ks_partner_token", data.token); return navigate(`/partner/${data.token}`, { replace: true }); }
          sessionStorage.setItem("ks_partner_google", JSON.stringify(data));
          navigate("/partner", { replace: true });
        })
        .catch((e) => fail(errMsg(e)));
      return;
    }
    api.post("/auth/google", { code: p.get("code"), redirect_uri: googleRedirect() })
      .then(({ data }) => {
        setUser(data);
        const next = localStorage.getItem("ks_after_login") || "/";
        localStorage.removeItem("ks_after_login");
        navigate(next, { replace: true });
      })
      .catch((e) => fail(errMsg(e)));
  }, []); // eslint-disable-line

  return <Splash />;
}
